import type { TipoEventoQuadro } from '../enums/dominios';
import type { PessoaResumoDto } from './licitacao';
import type { NotificacaoDto } from './notificacoes';

// Colaboração em tempo real (ADR-0008, RQ-COL-001 a RQ-COL-008): mensagens do Socket.IO entre front e API.
// O dado nunca viaja pelo socket: o evento diz o que mudou e o cliente relê pela API.

/** Cabeçalho HTTP com o id da aba, para a aba que gravou não reagir ao próprio evento. */
export const CABECALHO_CLIENTE = 'x-nexital-cliente';

/** Uma linha do outbox `quadro_evento`; `seq` cresce sempre dentro do quadro. */
export type EventoQuadroDto = {
  seq: number;
  tipo: TipoEventoQuadro;
  /** Processo (cartão ou licitação), grupo, nota ou conector afetado. */
  entidadeUuid: string;
  /** Aba que causou a mudança (null quando veio do sistema). */
  cliente: string | null;
  usuarioUuid: string | null;
};

export type EntrarQuadroPedido = { quadroUuid: string; /** null na primeira conexão. */ ultimoSeq: number | null };

/**
 * Resposta ao entrar na sala do quadro. Na reconexão, `eventos` traz o que foi perdido; `retrato` = true quando
 * a falta é antiga demais (mais de 7 dias ou eventos demais) e o cliente deve reler tudo.
 */
export type EntrarQuadroResposta =
  | { ok: true; seqAtual: number; eventos: EventoQuadroDto[]; retrato: boolean }
  | { ok: false };

/** Posição de um elemento enquanto é arrastado (não gravada, RQ-COL-002). `id` é o id do nó no quadro. */
export type ItemArrastado = { id: string; x: number; y: number };

export type ArrasteRemoto = { usuario: PessoaResumoDto; itens: ItemArrastado[] };

/** Trava leve de um elemento (RQ-COL-004). `chave` é o id do nó no quadro. */
export type TravaDto = { chave: string; usuario: PessoaResumoDto };

export type TravarResposta = { ok: true } | { ok: false; dono: PessoaResumoDto };

/** Mensagens do servidor para o cliente. */
export type EventosServidor = {
  evento: (evento: EventoQuadroDto) => void;
  presenca: (pessoas: PessoaResumoDto[]) => void;
  arrastando: (arraste: ArrasteRemoto) => void;
  travas: (travas: TravaDto[]) => void;
  /** Aviso novo para a pessoa conectada (sino), em qualquer quadro. */
  notificacao: (notificacao: NotificacaoDto) => void;
};

/** Mensagens do cliente para o servidor. */
export type EventosCliente = {
  entrar: (pedido: EntrarQuadroPedido, responder: (resposta: EntrarQuadroResposta) => void) => void;
  arrastando: (itens: ItemArrastado[]) => void;
  travar: (chave: string, responder: (resposta: TravarResposta) => void) => void;
  liberar: (chave: string) => void;
};
